import { func } from "prop-types";




export function getAccessToken() {

    return sessionStorage.getItem('access', null);

}

export function isAuthenticated() {
    const access = sessionStorage.getItem('access', null);
    console.log(`access >> ${access}`);

    if (access != null) {
        return true
    }

    return false
}

export default isAuthenticated;

export function saveUser(result) {

    console.log('saveUser', result);

    sessionStorage.setItem('refresh', result.refresh)
    sessionStorage.setItem('access', result.access)
    sessionStorage.setItem('first_name', result.account.first_name)
    sessionStorage.setItem('last_name', result.account.last_name)
    sessionStorage.setItem('phone', result.account.mobile)
    sessionStorage.setItem('email', result.account.email)
    sessionStorage.setItem('role', result.account.role)
    sessionStorage.setItem('photo', result.account.photo)
    sessionStorage.setItem('account_id', result.account.accountId)
    sessionStorage.setItem('is_active', result.account.is_active)


    sessionStorage.setItem('business_name', result.account.name)
    sessionStorage.setItem('logo', result.account.logo)
}

export function updateUser(result) {
    sessionStorage.setItem('first_name', result.user.first_name)
    sessionStorage.setItem('last_name', result.user.last_name)
    sessionStorage.setItem('phone', result.user.phone)
    sessionStorage.setItem('email', result.user.email)
    sessionStorage.setItem('role', result.user.role)
    sessionStorage.setItem('photo', result.user.photo)
    sessionStorage.setItem('account_id', result.user.account_id)
    sessionStorage.setItem('is_active', result.user.is_active)

    console.log('update', result.account.logo)
    sessionStorage.setItem('business_name', result.account.name)
    sessionStorage.setItem('logo', result.account.logo)
}

export function logout() {
    sessionStorage.removeItem('refresh')
    sessionStorage.removeItem('access')
    sessionStorage.removeItem('first_name')
    sessionStorage.removeItem('last_name')
    sessionStorage.removeItem('mobile')
    sessionStorage.removeItem('email')
    sessionStorage.removeItem('role')
    sessionStorage.removeItem('logo')
    sessionStorage.removeItem('business_name')

    sessionStorage.removeItem('school_id')
    sessionStorage.removeItem('logo')
    sessionStorage.removeItem('scope')
    sessionStorage.removeItem('company')
    sessionStorage.removeItem('address')
    sessionStorage.removeItem('loc_lat')
    sessionStorage.removeItem('loc_lon')
    sessionStorage.removeItem('state')
    sessionStorage.removeItem('city')
    sessionStorage.removeItem('country')

    localStorage.clear();

    console.log(`clear storage:`)
}

export function getUser() {
    return {
        access: sessionStorage.getItem('access', null),
        firstName: sessionStorage.getItem('first_name', null),
        lastName: sessionStorage.getItem('last_name', null),
        company: sessionStorage.getItem('company', null),
        email: sessionStorage.getItem('email', null),
        phone: sessionStorage.getItem('phone', null),
        role: sessionStorage.getItem('role', null),
    }
}

export function getLogo() {
    return sessionStorage.getItem('logo', null)
}
export function getBusinessname() {
    return sessionStorage.getItem('business_name', null)
}

export function getUserEmail() {
    return sessionStorage.getItem('email', null)
}

export function getSchoolId() {
    return sessionStorage.getItem('school_id', null)
}

const roleIdName = (role) => {
    switch (role) {
        case 'A':
            return 'Admin'
        case 'U':
            return 'Staff'
        default:
            return 'Analyst'
    }
}

export const roleName = () => {
    return roleIdName(sessionStorage.getItem('role', null));
}

export const roleId = () => {
    return sessionStorage.getItem('role', null);
}

export function isAdmin() {
    return (sessionStorage.getItem('role', null) === 'A')
}

export function getUserName() {
    return `${sessionStorage.getItem('first_name', '')} ${sessionStorage.getItem('last_name', '')}`
}

export function getUserId() {
    return sessionStorage.getItem('username', '')
}

export function getPhoto() {
    return sessionStorage.getItem('photo', '')
}
export function getLogin(result) {
    console.log('saveUser', result);

    sessionStorage.setItem('refresh', result.refresh)
    sessionStorage.setItem('access', result.access)
    sessionStorage.setItem('mobile', result.mobile)
    sessionStorage.setItem('passworld', result.passworld)
    sessionStorage.setItem('email', result.email)
    sessionStorage.setItem('role', result.role)
    sessionStorage.setItem('account_id', result.account_id)

}

export function setStoreDay(day, value) {
    // console.log('saveStoreData', day, value);
    sessionStorage.setItem(day, value);



}

export function setStore(storeSatuta) {
    sessionStorage.setItem('store_open', storeSatuta)
}

export function getStore() {
    // eslint-disable-next-line no-unneeded-ternary
    return sessionStorage.getItem('store_open') === 'true' ? true : false
}

export function getStoreDay(day) {
    // eslint-disable-next-line no-unneeded-ternary
    return sessionStorage.getItem(day,) === 'true' ? true : false
}